<template>
  <peel-hunt></peel-hunt>
</template>

<script>
import PeelHunt from "../components/Stock/Peel_Hunt.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Peel_Hunt_Container",
  components: {
    "peel-hunt": PeelHunt,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions(["getPeelhuntSectorsData", "getPeelhuntTableData"]),
  },
  mounted() {},
  created() {},
};
</script>

<style></style>
